import type { StateCreator } from 'zustand';
import type {
	FormValidationResult,
	SearchFormActions,
	SearchFormData,
	SearchFormState,
} from './types';

export interface SearchFormSlice {
	searchForm: SearchFormState;
	searchFormActions: SearchFormActions;
}

const initialState: SearchFormState = {
	formData: {
		dateTime: '',
	},
};

/**
 * Search form slice managing pickup, destination, date/time and form validation
 */
export const createSearchFormSlice: StateCreator<
	SearchFormSlice,
	[],
	[],
	SearchFormSlice
> = (set, get) => ({
	searchForm: initialState,

	searchFormActions: {
		updateFormData: (data: Partial<SearchFormData>) => {
			set((state) => ({
				searchForm: {
					...state.searchForm,
					formData: { ...state.searchForm.formData, ...data },
				},
			}));
			return get().searchForm.formData;
		},

		swapLocations: () => {
			set((state) => {
				const { pickup, drop } = state.searchForm.formData;
				return {
					searchForm: {
						...state.searchForm,
						formData: {
							...state.searchForm.formData,
							pickup: drop,
							drop: pickup,
						},
					},
				};
			});
		},

		validateForm: (): FormValidationResult => {
			const { formData } = get().searchForm;

			if (!formData.pickup) {
				return {
					isValid: false,
					errorMessage: 'Please select pickup address',
				};
			}

			if (!formData.drop) {
				return {
					isValid: false,
					errorMessage: 'Please select destination address',
				};
			}

			if (!formData.dateTime?.trim()) {
				return {
					isValid: false,
					errorMessage: 'Please select preferred time',
				};
			}

			const completeData: Required<SearchFormData> = {
				pickup: formData.pickup,
				drop: formData.drop,
				dateTime: formData.dateTime,
			};

			return {
				isValid: true,
				data: completeData,
			};
		},
	},
});
